import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { SendAuctionACommandHandler } from '@/Application/AuctionA'
import { AuctionAQueryRepository, AuctionACommandRepository } from '@/Domain/AuctionA'
import {
  InMemoryAuctionACommandRepository
} from '@/Infrastructure/AuctionA/Persistence/InMemory'
import { VuexAuctionAQueryRepository } from '@/Infrastructure/AuctionA/Persistence/Vuex'
import { AxiosAuctionACommandRepository } from '../Persistence/Axios'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'

export class SendAuctionACommandHandlerProvider
implements CommandHandlerProvider<SendAuctionACommandHandler> {
  provide (): SendAuctionACommandHandler {
    const queryRepository = this.getQueryRepository()
    const commandRepository = this.getCommandRepository()
    return new SendAuctionACommandHandler(queryRepository, commandRepository)
  }

  private getQueryRepository (): AuctionAQueryRepository {
    return new VuexAuctionAQueryRepository()
  }

  private getCommandRepository (): AuctionACommandRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryAuctionACommandRepository()
    }
    return new AxiosAuctionACommandRepository(new AxiosApiClient(new SessionTokenStorage()))
  }
}
